/**
 * Sidebar navigation — single source of truth for items, icons, routes and
 * section grouping. Mirrors the admin-prototype NAV plus a topbar title lookup.
 */
import React from 'react';
import {
  DashboardRounded, ViewAgendaRounded, StorefrontRounded,
  GroupRounded, CategoryRounded, PaymentRounded, AssessmentRounded,
  CardGiftcardRounded,
} from '@mui/icons-material';

export type Section = 'Dashboards' | 'Management' | 'Reports';

export interface NavItem {
  label: string;
  path: string;
  icon: React.ReactElement;
  section: Section;
}

export const NAV_ITEMS: NavItem[] = [
  { label: 'Admin Dashboard', path: '/dashboard', icon: <DashboardRounded />, section: 'Dashboards' },
  { label: "Today's Queue", path: '/todays-queue', icon: <ViewAgendaRounded />, section: 'Dashboards' },

  { label: 'Businesses', path: '/businesses', icon: <StorefrontRounded />, section: 'Management' },
  { label: 'Queues', path: '/queues', icon: <ViewAgendaRounded />, section: 'Management' },
  { label: 'Consumers & Tokens', path: '/consumers', icon: <GroupRounded />, section: 'Management' },
  { label: 'Categories', path: '/categories', icon: <CategoryRounded />, section: 'Management' },
  { label: 'Payments', path: '/payments', icon: <PaymentRounded />, section: 'Management' },
  { label: 'Trial Settings', path: '/trial-settings', icon: <CardGiftcardRounded />, section: 'Management' },

  { label: 'Provider Reports', path: '/provider-reports', icon: <AssessmentRounded />, section: 'Reports' },
  { label: 'Super Admin Reports', path: '/admin-reports', icon: <AssessmentRounded />, section: 'Reports' },
];

export const SECTIONS: Section[] = ['Dashboards', 'Management', 'Reports'];

/** Topbar title + breadcrumb for a path (longest-prefix match). */
export function pageMetaFor(pathname: string): { title: string; crumbs: string } {
  const meta: Array<[string, string, string]> = [
    ['/dashboard', 'Dashboard', 'Platform overview · Super Admin'],
    ['/provider-dashboard', 'Provider Dashboard', 'Swapnapurti Clinic · Today'],
    ['/todays-queue', "Today's Queue", "Provider · Today's Queue"],
    ['/businesses', 'Businesses', 'Management · Businesses'],
    ['/queues', 'Queues', 'Management · Queues'],
    ['/consumers', 'Consumers & Tokens', 'Management · Consumers'],
    ['/categories', 'Service Categories', 'Management · Categories'],
    ['/payments', 'Payments', 'Management · Payments'],
    ['/trial-settings', 'Trial Settings', 'Management · Free Trial'],
    ['/provider-reports', 'Provider Reports', 'Reports · Provider'],
    ['/admin-reports', 'Reports', 'Reports · Platform'],
  ];
  const m = meta.find(([p]) => pathname === p || pathname.startsWith(p + '/'));
  return m ? { title: m[1], crumbs: m[2] } : { title: 'BaseQueue', crumbs: '' };
}
